import { Switch } from "antd";
import { FC } from "react";

import styles from "./index.less";

interface RenewSwitcherProps {
  value?: boolean;
  onChange?: (value: boolean) => void;
}

/**
 * 开关自动续费
 * @returns
 */
const RenewSwitcher: FC<RenewSwitcherProps> = ({ value, onChange }) => {
  return (
    <div className={styles["renew-switcher"]}>
      <div>
        <div className={styles["title"]}>自动续费</div>
        <div className={styles["description"]}>
          自动续费仅可扣除账户可用余额，请确保余额充足
        </div>
      </div>

      <Switch checked={value} onChange={onChange} />
    </div>
  );
};

export default RenewSwitcher;
